<template>
  <div>
    <vs-table :sst="true" @sort="handleSort" v-model="selected" max-items="rows" :data="itemData">
      <template slot="header">
        <h3 v-if="this.$props.header">{{ header }}</h3>
      </template>
      <template slot="thead">
        <vs-th :key="ind" v-for="(col, ind) in columns" :sort-key="col.field">{{col.name}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :key="i" v-for="(item, i) in columns" :data="tr[item.field]">{{tr[item.field]}}</vs-td>
          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full">
              <div class="con-btns-user flex items-center justify-start">
                <div class="con-userx flex items-center justify-start">
                  <!-- <span>{{ tr.name }}</span> -->
                </div>
                <div class="flex">
                  <vx-tooltip :text="$t('GENERAL').Edit" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="mr-2"
                      @click="onEdit(tr)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip :text="$t('GENERAL').Delete" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      @click="onDelete(tr)"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </div>
              <vs-list v-if="hasMoreInfoData">
                <vs-list-item
                  :key="index"
                  v-for="(item, index) in moreInfoData"
                  :title="`${item.name}: `"
                  :subtitle="tr[item.field]"
                ></vs-list-item>
                <!-- <vs-list-item icon-pack="feather" icon="icon-globe" :title="tr.website"></vs-list-item> -->
              </vs-list>
            </div>
          </template>
        </vs-tr>
      </template>
    </vs-table>

    <div class="row table-pagination" v-if="displayPagination">
      <vs-pagination
        :class="hasPaginationAlign()"
        :total="totalPages + 1"
        v-model="currentPage"
        @change-page="handleChangePage"
      ></vs-pagination>
      <vs-select label="Itens por página" v-model="currentRow">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item,index) in pageSizeOptions"
        />
      </vs-select>
    </div>
  </div>
</template>

<script>
import AppConstants from "../../appConstants";
export default {
  mounted() {},
  name: "generic-table-pagination",
  created() {
    this.pageSizeOptions = AppConstants.PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS;
  },
  props: {
    header: String,
    itemData: {},
    columns: {
      type: Array
    },
    rows: Number,
    totalPages: Number,
    paginationAlign: String,
    moreInfoData: null
  },
  data: () => ({
    selected: null,
    currentPage: 1,
    pageSizeOptions: [],
    currentRow: AppConstants.PAGINATOR_DEFAULT_LIMIT
  }),
  methods: {
    handleChangePage(page) {
      this.$emit("pageChange", page);
    },
    handleSort(key, active) {
      // let _print = `the user ordered: ${key} ${active}\n`;
      // console.log(_print);
      this.$emit("sortChange", { key: key, active: active });
    },
    handleChangeRows(row) {
      this.$emit("rowChange", row);
    },
    onEdit(data) {
      // console.log("edit", data);
      this.$emit("click-edit", data);
    },
    onDelete(data) {
      // console.log("delete", data);
      this.$emit("click-delete", data);
    },
    hasPaginationAlign() {
      if (this.paginationAlign === "start") {
        return "pagination-align-start";
      }
      if (this.paginationAlign === "end") {
        return "pagination-align-end";
      }
      return "";
    }
  },
  computed: {
    hasMoreInfoData() {
      if (this.moreInfoData) {
        return this.moreInfoData.length > 0;
      }
      return false;
    },
    displayPagination() {
      return this.totalPages >= 1;
    }
  },
  watch: {
    currentPage: function(val) {
      this.handleChangePage(val);
    },
    currentRow: function(val) {
      this.handleChangeRows(val);
    }
  }
};
</script>

<style>
.table-pagination {
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
}
.table-pagination .con-vs-pagination {
  width: 100%;
}
.table-pagination nav {
  margin-top: 10px;
}
.pagination-align-start nav {
  justify-content: start;
}
.pagination-align-center nav {
  justify-content: center;
}
.pagination-align-end nav {
  justify-content: end;
}
</style>